import styled from '@emotion/styled'

export const ReportsFiltersWrapper = styled.div``
